<template>
  <div>
    <b-form-group label="Size">
      <b-input-group>
        <b-input
          v-model="size"
          :max="200"
          :min="0"
          type="range"
          @input="changeEffect"
        />
        <template #append>
          <b-input
            v-model="size"
            :max="100"
            :min="0"
            type="number"
            @input="changeEffect"
          />
        </template>
      </b-input-group>
    </b-form-group>
    <b-form-group label="Spread">
      <b-input-group>
        <b-input
          v-model="spread"
          :max="100"
          :min="0"
          type="range"
          @input="changeEffect"
        />
        <template #append>
          <b-input
            v-model="spread"
            :max="100"
            :min="0"
            type="number"
            @input="changeEffect"
          />
        </template>
      </b-input-group>
    </b-form-group>
    <b-form-group label="Color">
      <ColorPicker
        v-model="color"
        opacity
        copy
        position="right-middle"
        @input="changeEffect"
      />
    </b-form-group>
  </div>
</template>

<script>

import ColorPicker from "@frontend/components/modules/layouts-page/EditorControl/components/ColorPicker.vue";

export default {
  name: 'OuterGlowEffect',
  components: {ColorPicker},
  props: {
    target: {
      type: Object,
      default: () => ({}),
    }
  },
  data: () => ({
    size: 0,
    spread: 0,
    color: 'rgba(0,0,0,0.5)'
  }),
  watch: {
    target: {
      handler (val) {
        this.size = val?.outerGlow?.size ?? 0
        this.spread = val?.outerGlow?.spread ?? 0
        this.color = val?.outerGlow?.color ?? 'rgba(0,0,0,0.5)'
      },
      immediate: true,
    },
  },
  methods: {
    changeEffect() {
      this.target.set({
        outerGlow: {
          size: Number(this.size),
          spread: Number(this.spread),
          color: this.color
        }
      });
      this.target.canvas.fire('effects:changed', this.target);
      this.target.canvas.renderAll();
    }
  }
}

</script>
